"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _CategoriesSideBarNavigation = _interopRequireDefault(require("@insided/destination/modules/Categories/CategoriesSideBarNavigation"));

var cssAnchorName = 'knowledge-base-navigation';
exports.cssAnchorName = cssAnchorName;

var NavigationLoader = function NavigationLoader(_ref) {
  var currentCategory = _ref.currentCategory,
      categoriesV2 = _ref.categoriesV2;
  return (0, _preact.h)(_CategoriesSideBarNavigation.default, {
    currentCategory: currentCategory,
    categories: categoriesV2
  });
};

var _default = NavigationLoader;
exports.default = _default;